module.exports = __webpack_public_path__ + "img/coin_place_holder.b2f2e338.png";